import { createContext, useContext, useEffect } from "react";
import { useGetTheme } from "../api/Brand";
import THEME from "../config/theme";
import { setDefaultPageBackground } from "../utils/pageBackground";

const UseCustomTheme = createContext({});

export const CustomThemeProvider = ({ children }) => {
  const { data: customColor, isLoading: isLoadingColorInfo } =
    useGetTheme("colors");
  const { data: customFont, isLoading: isLoadingFont } = useGetTheme("fonts");
  const { data: customInfo, isLoading: isLoadingCustomInfo } =
    useGetTheme("infos");

  // Fundo PADRÃO da página (o <body>) — ver `utils/pageBackground`. Telas com
  // paleta própria, como o login, sobrepõem com `usePageBackground`.
  const pageBackground = customColor?.background?.app;

  useEffect(() => {
    setDefaultPageBackground(pageBackground || THEME.COLORS.BACKGROUND_MAIN);
  }, [pageBackground]);

  return (
    <UseCustomTheme.Provider
      value={{
        customColor,
        customFont,
        customInfo,
        isLoadingColorInfo,
        isLoadingFont,
        isLoadingCustomInfo,
      }}
    >
      {children}
    </UseCustomTheme.Provider>
  );
};
export const useCustomTheme = () => {
  const context = useContext(UseCustomTheme);

  if (!context) {
    throw new Error(
      "useCustomTheme must be used within an CustomThemeProvider"
    );
  }

  return context;
};
